import React from 'react';

/**
 * Decorative-only SVG for auth backgrounds: abstract curves, nodes, and soft
 * grid suggesting connected commerce / data flows — aligned with how Klickly
 * describes distributed, full-funnel commerce on klickly.com.
 */
export const AuthAmbientBackdrop = () => (
    <div className='auth-page__ambient' aria-hidden='true'>
        <svg
            className='auth-page__ambient-svg'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 1600 900'
            preserveAspectRatio='xMidYMid slice'
            focusable='false'
        >
            <path
                className='auth-page__ambient-line auth-page__ambient-line--a'
                fill='none'
                strokeWidth='1.15'
                strokeLinecap='round'
                d='M -40 720 C 220 560 380 620 560 520 S 920 360 1220 420 S 1540 520 1680 380'
            />
            <path
                className='auth-page__ambient-line auth-page__ambient-line--b'
                fill='none'
                strokeWidth='1'
                strokeLinecap='round'
                d='M 120 -60 C 320 180 260 420 480 540 S 820 640 1080 560 S 1420 420 1620 780'
            />
            <path
                className='auth-page__ambient-line auth-page__ambient-line--c'
                fill='none'
                strokeWidth='0.85'
                strokeLinecap='round'
                strokeDasharray='6 14'
                d='M -80 260 C 200 220 420 320 640 240 S 1040 120 1320 200 S 1580 360 1700 260'
            />

            <g className='auth-page__ambient-nodes'>
                <circle cx='560' cy='520' r='5' />
                <circle cx='920' cy='400' r='4' />
                <circle cx='1220' cy='420' r='4.5' />
                <circle cx='480' cy='540' r='3.5' />
                <circle cx='1080' cy='560' r='3.5' />
                <circle cx='260' cy='680' r='3' />
                <circle cx='1380' cy='320' r='3' />
            </g>

            <g className='auth-page__ambient-grid'>
                <path
                    fill='none'
                    strokeWidth='0.7'
                    strokeDasharray='4 18'
                    d='M 140 140 H 1460 M 140 260 H 1460 M 140 380 H 1460 M 140 500 H 1460 M 140 620 H 1460 M 140 740 H 1460'
                />
                <path
                    fill='none'
                    strokeWidth='0.7'
                    strokeDasharray='4 18'
                    d='M 260 80 V 820 M 420 80 V 820 M 580 80 V 820 M 740 80 V 820 M 900 80 V 820 M 1060 80 V 820 M 1220 80 V 820'
                />
            </g>

            <g className='auth-page__ambient-tiles'>
                <rect x='1080' y='120' width='88' height='64' rx='14' ry='14' transform='rotate(-8 1124 152)' />
                <rect x='200' y='560' width='96' height='70' rx='16' ry='16' transform='rotate(6 248 595)' />
                <rect x='1240' y='620' width='76' height='56' rx='12' ry='12' transform='rotate(-14 1278 648)' />
            </g>
        </svg>
    </div>
);
